import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { buildBreadcrumb } from '../../config/navigation';

// Breadcrumb "Home / Macro / Sotto" — derivato dalla route corrente via config
// (fonte unica navigation.js). Presentazionale: nessuno stato, nessun fetch.
// Reso nella topbar (Layout); su Home mostra solo "Home".
export default function Breadcrumb() {
  const { pathname } = useLocation();
  const items = buildBreadcrumb(pathname);
  if (!items) return null;

  return (
    <nav aria-label="Percorso" style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0, flexWrap: 'wrap', fontSize: 13, color: 'var(--ds-muted)' }}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${it.label}-${i}`} style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0 }}>
            {i > 0 && <ChevronRight size={14} strokeWidth={1.8} color="var(--ds-muted)" style={{ flexShrink: 0, opacity: 0.7 }} />}
            {last || !it.to ? (
              <span style={{ color: last ? 'var(--ink)' : 'var(--ds-muted)', fontWeight: last ? 500 : 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {it.label}
              </span>
            ) : (
              <Link
                to={it.to}
                style={{ color: 'var(--ds-muted)', textDecoration: 'none', whiteSpace: 'nowrap' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--ink)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--ds-muted)'; }}
              >
                {it.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
